
export class Video {
    constructor(
        public url: string
        ) {
    }
}